export default {
  APP_POST_REQUEST: "APP_POST_REQUEST",
  APP_POST_RECIEVE: "APP_POST_RECIEVE",
  APP_POST_ERROR: "APP_POST_ERROR"
};
